import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './TopHeader.scss';
import containerWidth from '../../../shared/helpers/containerWidth';
import CompanyName from '../CompanyName/CompanyName';

const TopHeader = ({ companyName, brandingColor, logoUrl }) => (
  <div className="row top_header">
    <div className="col-12">
      <div className="top_header__background" />
    </div>
    <div className={containerWidth}>
      <div className="company-logo-square">
        {logoUrl ? (
          <img src={logoUrl} alt="" className="top_header__img-logo" />
        ) : (
          <CompanyName companyName={companyName} companyColor={brandingColor} />
        )}
      </div>
    </div>
  </div>
);

TopHeader.propTypes = {
  companyName: PropTypes.string.isRequired,
  brandingColor: PropTypes.string,
  logoUrl: PropTypes.string,
};
TopHeader.defaultProps = {
  brandingColor: '8fc748',
  logoUrl: null,
};

export default connect((state) => ({
  companyName: state.companyDetails.name,
  brandingColor: state.companyDetails.brandingColor,
  logoUrl: state.companyDetails.logoUrl,
}))(TopHeader);
